import React, { useEffect, useState } from 'react';
import ImageListItem                   from '@mui/material/ImageListItem';
import ImageListItemBar                from '@mui/material/ImageListItemBar';
import IconButton                     from '@mui/material/IconButton';
import DeleteIcon                     from '@mui/icons-material/Delete';
import { Skeleton } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
	icon: {
		color: 'rgba(255, 255, 255, 0.54)',
		'&:hover': {
			color: 'rgba(255, 255, 255, 0.8)',
		}
	},
	img: {
		maxHeight: '180px',
		maxWidth: '240px',
		overflow: 'hidden'
	}
}));

const GalleryImg = ({ idx, file, onRemove, ...rest }) => {
	const [src, setSrc] = useState(null);
	const classes = useStyles();

	useEffect(() => {
		if (FileReader && file) {
			const fr = new FileReader();
			fr.onload = function () {
				setSrc(fr.result);
			};
			fr.readAsDataURL(file);
		}
	}, [setSrc, file]);

	return (
        <ImageListItem className={classes.img} {...rest}>
            {!src && <Skeleton width={200} height={180}/>}
            {src && <img src={src} alt={file.name}/>}
            <ImageListItemBar
				title={file.name}
				actionIcon={
					<IconButton
                        className={classes.icon}
                        onClick={() => {
                            onRemove(idx);
                        }}
                        size="large">
						<DeleteIcon/>
					</IconButton>
				}
			/>}
                    </ImageListItem>
    );
};

export default GalleryImg;
